import registerHook from '../../files/registerHook';
import FiltersPanel from '../../files/filtersPanel';
import TransformsPanel from '../../files/transformsPanel';
import EntranceAnimationsPanel from '../../files/entranceanimations';
import PullPanel from '../../files/pullPanel';
import GeneralPanel from '../../files/generalPanel';
import MaskPanel from '../../files/maskPanel';
import {getInlineStylesGeneral,getInlineVariable,getInlineHoverVariable,getInlineTransform,getInlineHoverTransform,getClasses} from '../../files/utils';


/* eslint-disable react/jsx-props-no-spreading, react/prop-types */
import classnames from 'classnames';
//import colorconvert from 'color-convert';
import { colord } from "colord";

// below here for testing imports
import { RangeControl } from '@wordpress/components';
//import { AnglePickerControl } from '@wordpress/components';
//import { GradientPicker } from '@wordpress/components';
import { Button,ButtonGroup } from '@wordpress/components';
import { useState } from '@wordpress/element';
import { CustomSelectControl } from '@wordpress/components';
import { Flex, FlexBlock, FlexItem } from '@wordpress/components';
import { ToggleControl, CheckboxControl } from '@wordpress/components';



//import { useSelect } from '@wordpress/data';
//import { useSetting } from '@wordpress/block-editor';
// end testing imports

const { assign, merge } = lodash;

const { __ } = wp.i18n;
const { addFilter } = wp.hooks;
const { createHigherOrderComponent } = wp.compose;
const { Fragment } = wp.element;
const { InspectorControls } = wp.blockEditor;
const { PanelBody, SelectControl, RadioControl } = wp.components;

const blocksToModify = ['core/gallery','core/group', 'core/columns', 
						'core/column', 'core/cover', 'core/image', 'core/heading', 
						'core/paragraph','core/button','core/buttons','core/media-text',
						'core/post-template','aploblocks/tabs','aploblocks/accordion',
						'core/post-title','core/post-featured-image'];




/**
 * Add Effect attribute to Button block
 *
 * @param  {Object} settings Original block settings
 * @param  {string} name     Block name
 * @return {Object}          Filtered block settings
 */
function addAttributes(settings, name) {

	//console.log(name);
	// adds the attributes to the block
	return registerHook(settings,name,blocksToModify);
}

addFilter(
	'blocks.registerBlockType',
	'aploeffects/group/add-attributes',
	addAttributes,
);

/**
 * Add Effect control to Button block
 */
const addInspectorControl = createHigherOrderComponent((BlockEdit) => {
	return (props) => {
		
		// probably remove these
		const {
			attributes: { aploeffect },
			attributes: { aploeffectease },
			attributes: { aploeffectdelay },
			attributes: { aploeffectduration },
			attributes: { aplotexture },
            attributes: { aploshadow },
			attributes: { aplocoveroverlay },
			attributes: { aplopatterngroup },
			attributes: { aplomask },
			attributes: { aplofilters },
			attributes: { aplofiltersHover },
			attributes: { backdropFilter},
			attributes: {hasFilters},
			attributes: {hasHoverFilters},
			attributes: {galleryswitch},
			attributes: {aplotransforms},
			attributes: {aplotransformsHover},
			attributes: {hasTransforms},
			attributes: {hasHoverTransforms},
			attributes: {aplohoverduration},
			attributes: {aplohoverease},
			/*attributes: {aploposition},*/
			attributes: {aplozindex},
			attributes: {aplomargintop},
			attributes: {aplomarginbottom},
			attributes: {aplomarginleft},
			attributes: {aplomarginright},
			/*attributes: {aplopositiontop},
			attributes: {aplopositionbottom},
			attributes: {aplopositionleft},
			attributes: {aplopositionright},*/
			attributes: {aploclip},
			attributes: {overflowhidden},
			attributes: {haspullstyles},
			attributes: {aploanimation},
			setAttributes,
			name,
		} = props;

		if (blocksToModify.includes(name) === false) {
			return <BlockEdit {...props} />;
		}
		

		return (
			<Fragment>
				<BlockEdit {...props} />
				<InspectorControls>

					<EntranceAnimationsPanel props={props} />
										
					<TransformsPanel props={props} />

					<FiltersPanel props={props} />

					<MaskPanel props={props} />

					<PullPanel props={props} />
				
					<GeneralPanel props={props} />


				</InspectorControls>
			</Fragment>
		);
	};
}, 'withInspectorControl');

addFilter(
	'editor.BlockEdit',
	'aploeffects/group/add-inspector-controls',
	addInspectorControl,
);

/**
 * Add effect class to the block in the editor
 */
const addEffectClassEditor = createHigherOrderComponent((BlockListBlock) => {
	return (props) => {
		const {
			attributes: { aploeffect },
			attributes: { aploeffectdelay },
			attributes: { aploeffectduration },
			attributes: {aplofilters},
			attributes: {aplofiltersHover},
			attributes: {backdropFilter},
			attributes: {hasFilters},
			attributes: {hasHoverFilters},
			attributes: {shadowInvert},
			attributes: {aplotransforms},
			attributes: {aplotransformsHover},
			attributes: {hasTransforms},
			attributes: {hasHoverTransforms},
			attributes: {aplohoverduration},
			className,
			name,
		} = props;

		if (blocksToModify.includes(name) === false) {
			return <BlockListBlock {...props} />;
		}

	const effectDuration = aploeffect && aploeffectduration ? {"--aplo-tedu":aploeffectduration + "ms"} : {};
	const effectDelay = aploeffect && aploeffectdelay ? {"--aplo-tede":aploeffectdelay + "ms"} : {}; 

	const inlineStyle = hasFilters > 0 ? getInlineVariable(aplofilters) : '';
	const inlineHoverStyle = hasHoverFilters > 0 ? getInlineHoverVariable(aplofiltersHover) : '';
	//const inlineTransform = getInlineTransform(props.attributes);
	const inlineTransformStyle = hasTransforms > 0 ? getInlineTransform(aplotransforms) : '';
	const inlineTransformHoverStyle = hasHoverTransforms > 0 ? getInlineHoverTransform(aplotransformsHover) : '';
	const hoverDuration = aplohoverduration ? {"--aplo-thdu":aplohoverduration + "ms"} : {};
	const inlineStylesGeneral = getInlineStylesGeneral(props.attributes);
	//console.log(inlineStylesGeneral);


	let wrapperProps = {...props.wrapperProps};

	wrapperProps.style = {...wrapperProps.style,...inlineStyle,...inlineHoverStyle,...inlineTransformStyle,...inlineTransformHoverStyle,...hoverDuration,...effectDuration,...effectDelay,...inlineStylesGeneral}	
	
	wrapperProps.style = {...wrapperProps.style}
	

		return (<>
			<BlockListBlock
				{...props}
				wrapperProps={wrapperProps}
				className={getClasses(className,props.attributes,false)}
            /> </>
		)};
}, 'withClientIdClassName');

addFilter(
	'editor.BlockListBlock',
	'aploeffects/group/add-editor-class',
	addEffectClassEditor,
);

/**
 * Add effect class to the block on the front end
 *
 * @param  {Object} props      Additional props applied to save element.
 * @param  {Object} block      Block type.
 * @param  {Object} attributes Current block attributes.
 * @return {Object}            Filtered props applied to save element.
 */
function addEffectClassFrontEnd(props, block, attributes) {
	if (blocksToModify.includes(block.name) === false) {
		return props;
	}

	const { className } = props;
	const { style } = props;
	const { aploeffect } = attributes;
	const { aploeffectdelay } = attributes;
	const { aploeffectduration } = attributes;
	const { aplofilters } = attributes;
	const { aplofiltersHover } = attributes;
	const { backdropFilter } = attributes;
	const { hasFilters} = attributes;
	const { hasHoverFilters} = attributes;
	const { shadowInvert} = attributes;
	const { hasTransforms} = attributes;
	const { hasHoverTransforms} = attributes;
	const { aplotransforms} = attributes;
	const { aplotransformsHover} = attributes;
	const { aplohoverduration} = attributes;

	const effectDuration = aploeffect &&  aploeffectduration ? {"--aplo-tedu":aploeffectduration + "ms"} : {};
	const effectDelay = aploeffect && aploeffectdelay ? {"--aplo-tede":aploeffectdelay + "ms"} : {}; 

	const inlineStyle = hasFilters > 0 ? getInlineVariable(aplofilters) : '';
	
	const inlineHoverStyle = hasHoverFilters > 0 ? getInlineHoverVariable(aplofiltersHover) : '';
	//const inlineTransform = getInlineTransform(attributes);
	const inlineTransformStyle = hasTransforms > 0 ? getInlineTransform(aplotransforms) : '';
	const inlineTransformHoverStyle = hasHoverTransforms > 0 ? getInlineHoverTransform(aplotransformsHover) : '';
	const hoverDuration = aplohoverduration ? {"--aplo-thdu":aplohoverduration + "ms"} : {};
	const inlineStylesGeneral = getInlineStylesGeneral(attributes);


	return assign({}, props, {

		className: getClasses(className,attributes,true),
		style:{...style,...inlineStyle,...inlineHoverStyle,...inlineTransformStyle,...inlineTransformHoverStyle,...hoverDuration,...effectDuration,...effectDelay,...inlineStylesGeneral},
	});
}


addFilter(
	'blocks.getSaveContent.extraProps',
	'aploeffects/group/add-front-end-class',
	addEffectClassFrontEnd,
);

